type QueryParams = {
  bundle: string
  staging: boolean
  hideLogo: boolean
  wallmounted: boolean
  testmode: boolean
}

export const booleanParamValue = (
  urlSearchParams: URLSearchParams,
  paramKey: string,
) => {
  return (
    urlSearchParams.has(paramKey) || urlSearchParams.get(paramKey) === 'true'
  )
}

export function getQueryParameters(query: string): QueryParams {
  const urlSearchParams = new URLSearchParams(query)
  const result: QueryParams = {
    bundle: urlSearchParams.get('bundle') || '',
    staging: booleanParamValue(urlSearchParams, 'staging'),
    hideLogo: booleanParamValue(urlSearchParams, 'hideLogo'),
    wallmounted: booleanParamValue(urlSearchParams, 'wallmounted'),
    testmode: booleanParamValue(urlSearchParams, 'testmode'),
  }
  return result
}

export function getBundleId(urlQueryParams: QueryParams): string {
  return urlQueryParams && urlQueryParams.bundle ? urlQueryParams.bundle : ''
}

export const orbitParamsFromEulerAngles = (euler_angles = [0, 0, 0]) => {
  const [pitch = 0, yaw = 0] = euler_angles
  const theta = yaw * (180 / Math.PI)
  const phi = (pitch + Math.PI / 2) * (180 / Math.PI)
  return `${theta}deg ${phi}deg 100%`
}

export const deriveProperty = (
  fromParams: boolean | undefined,
  fromProps: boolean,
  fromBundle: boolean | undefined,
) => {
  //if fromParams is defined
  if (fromBundle) {
    return fromParams || fromProps || fromBundle
  } else {
    return fromParams || fromProps
  }
}
